import React, { useState, useEffect, useMemo } from "react";
import {
  Background,
  Buttons,
  Container,
  ContainerTable,
  Grup,
  Menus,
  QtdeProgre,
  Table,
  Tbody,
  Td,
  Th,
  Theader,
  Title,
  Trbody,
} from "./style";
import Button from "../../Components/Button";
import Pesquisar from "../../Components/Pesquisar";
import api from "../../Services/api";
import { format } from "date-fns/esm";
import { FaEye, FaRegQuestionCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Alert } from "../../utils/Alert";
import { RiIndeterminateCircleFill } from "react-icons/ri";
import { IoMdCheckmarkCircle } from "react-icons/io";
import InputSelect from "../../Components/Select";
import PDFVisualizarProgre from "../../utils/pdf";

function VisualizarProgreCoord() {
  const [progressoes, setProgressoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gerandoPDF, setGerandoPDF] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [limite] = useState(10);
  const [searchId, setSearchId] = useState("");
  const [searchRm, setSearchRm] = useState("");
  const [searchNome, setSearchNome] = useState("");
  const [searchTurma, setSearchTurma] = useState("");
  const [searchDisciplina, setSearchDisciplina] = useState("");
  const [searchCumpriu, setSearchCumpriu] = useState(null);
  const [searchConceito, setSearchConceito] = useState("");
  const [searchDataAceito, setSearchDataAceito] = useState("");
  const [searchDataResultado, setSearchDataResultado] = useState("");
  const [searchProfessor, setSearchProfessor] = useState("");

  const optionsCumpriu = [
    { label: "Em andamento", value: "null" },
    { label: "Todos", value: "" },
    { label: "Entregue", value: 1 },
    { label: "Não entregue", value: 0 },
   
  ];
  const optionsConceito = [
    { label: "Todos", value: "" },
    { label: "Apto", value: "apto" },
    { label: "Inapto", value: "inapto" },
  ];

  const navigate = useNavigate();

  /////////////////////////////////PDF
  const { gerarPDF } = PDFVisualizarProgre();
  ///////////////////////////////////
  useEffect(() => {
    ListarProgressoes();
  }, []);

  async function ListarProgressoes() {
    setLoading(true);
    try {
      const { data } = await api.get("/coordenador/listar-alunos-progressao", {
        headers: {
          "x-page": 1,
          "x-limite": 10000,
        },
      });
      // console.log(data);

      if (data.erro) {
        setProgressoes([]);
        setTotalPages(0);
        setTotalItems(0);
        return;
      }
      setProgressoes(data.progressoes || []);
      setTotalItems((data.progressoes || []).length);
      // Se a página atual é maior que o total de páginas, voltar para página 1
      if (page > data.totalPage && data.totalPage > 0) {
        setPage(1);
      }
    } catch (error) {
      console.error("Erro ao carregar progressões:", error);
      setProgressoes([]);
      setTotalPages(0);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }
  function handlePageChange(newPage) {
    if (newPage >= 1 && newPage <= totalPages && newPage !== page) {
      setPage(newPage);
    }
  }

  function somenteCampo(dado, semMaiusculo = false, tudoMaiusculo = false) {
    if (!dado) return dado;
    let resultado = dado;
    if (resultado?.includes(",")) {
      resultado = resultado.split(",")[1].trim();
    }
    const upper = resultado.toUpperCase();
    if (upper?.includes("TÉCNICO EM") || upper?.includes("TECNICO EM")) {
      resultado = resultado.replace(/TÉCNICO EM|TECNICO EM/gi, "").trim();
    }
    if (upper?.includes("TÉCNOLOGO EM") || upper?.includes("TECNOLOGO EM")) {
      resultado = resultado.replace(/TÉCNOLOGO EM|TECNOLOGO EM/gi, "").trim();
    }
    if (semMaiusculo) return resultado;
    if (tudoMaiusculo) return resultado.toUpperCase();
    return resultado.charAt(0).toUpperCase() + resultado.slice(1).toLowerCase();
  }

  function formatarData(data) {
    try {
      return data ? format(new Date(data), "dd/MM/yyyy") : <p>-</p>;
    } catch (error) {
      return "Data inválida";
    }
  }

  function formatarStatus(status) {
    return {
      texto: status == 1 ? "ENTREGUE" : status == 0 ? "NÃO ENTREGUE" : "EM ANDAMENTO",
      color: status == 1 ? "green" : status == 0 ? "red" : "gray",
    };
  }

  async function ConfirmarEnvio(id_progressao, id_aluno) {
    // const { isConfirmed } = await Alert({
    //   tipo: "Alert",
    //   mensagem: "(mensagem provisoria)Confirmar envio pro sofia?",
    // });
    // if (isConfirmed) {
    try {
      const response = await api.put(`/usuario/definir-progre-enviada`, { id_progressao, id_aluno });
      if (response?.status !== 200) {
        Alert({ tipo: "Erro2", mensagem: response.data.erro || "Falha ao confirmar!" });
      }
      Alert({ tipo: "Sucesso-popup", mensagem: response.data.mensagem || "Envio confirmado!", tempo: 1500 });
    } catch (err) {
      console.error(err);
      Alert({ tipo: "Erro2", mensagem: err.response.data?.erro || "Falha ao confirmar!" });
    } finally {
      ListarProgressoes();
    }
    return;
    // }
  }

  const normalizeString = (str) => {
    return String(str || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const filteredProgressoes = useMemo(() => {
    const searchIdNormalized = normalizeString(searchId);
    const searchRmNormalized = normalizeString(searchRm);
    const searchNomeNormalized = normalizeString(searchNome);
    const searchTurmaNormalized = normalizeString(searchTurma);
    const searchDisciplinaNormalized = normalizeString(searchDisciplina);
    const searchDataAceitoNormalized = normalizeString(searchDataAceito);
    const searchDataResultadoNormalized = normalizeString(searchDataResultado);
    const searchProfessorNormalized = normalizeString(searchProfessor);

    const extamenteCumpriu = (val) =>
      searchCumpriu === "" || (searchCumpriu === "null" && val === null) || val == searchCumpriu;

    const extamenteConceito = (val) => searchConceito === "" || val == searchConceito;

    return progressoes.filter((p) => {
      return (
        normalizeString(p.id_progressao).includes(searchIdNormalized) &&
        normalizeString(p.rm).includes(searchRmNormalized) &&
        normalizeString(p.nome).includes(searchNomeNormalized) &&
        normalizeString(p.turma_rh).includes(searchTurmaNormalized) &&
        normalizeString(p.disciplina_rh).includes(searchDisciplinaNormalized) &&
        normalizeString(p.aluno_aceitou).includes(searchDataAceitoNormalized) &&
        normalizeString(p.data_resultado).includes(searchDataResultadoNormalized) &&
        normalizeString(p.professor).includes(searchProfessorNormalized) &&
        extamenteCumpriu(p.cumpriu) &&
        extamenteConceito(p.conceito)
      );
    });
  }, [
    progressoes,
    searchId,
    searchRm,
    searchNome,
    searchTurma,
    searchDisciplina,
    searchDataAceito,
    searchDataResultado,
    searchCumpriu,
    searchConceito,
    searchProfessor,
  ]);
  const paginatedProgressoes = useMemo(() => {
    const startIndex = (page - 1) * limite;
    return filteredProgressoes.slice(startIndex, startIndex + limite);
  }, [filteredProgressoes, page, limite]);

  useEffect(() => {
    const newTotalPages = Math.max(1, Math.ceil(filteredProgressoes.length / limite));
    setTotalPages(newTotalPages);
    setTotalItems(filteredProgressoes.length);
    if (page > newTotalPages) {
      setPage(newTotalPages);
    }
  }, [filteredProgressoes, limite, page]);

  useEffect(() => {
    setPage(1);
  }, [
    searchId,
    searchRm,
    searchNome,
    searchTurma,
    searchDisciplina,
    searchDataAceito,
    searchDataResultado,
    searchCumpriu,
    searchConceito,
    searchProfessor,
  ]);
  /////////////////////////////////PDF
  async function handleGerarPDF() {
    if (gerandoPDF) return;

    if (!filteredProgressoes.length) {
      Alert({
        tipo: "Erro",
        mensagem: "Não há dados para gerar o relatório.",
      });
      return;
    }

    setGerandoPDF(true);

    try {
      const { data } = await api.get("/coordenador/listar-alunos-progressao", {
        headers: {
          "x-page": 1,
          "x-limite": 10000,
        },
      });

      if (data.erro) {
        Alert({
          tipo: "Erro",
          mensagem: "Erro ao buscar dados para o relatório.",
        });
        return;
      }
      const todosOsDados = data.progressoes || [];
      const dadosFiltrados = todosOsDados.filter((p) => {
        const searchIdNormalized = normalizeString(searchId);
        const searchRmNormalized = normalizeString(searchRm);
        const searchNomeNormalized = normalizeString(searchNome);
        const searchTurmaNormalized = normalizeString(searchTurma);
        const searchDisciplinaNormalized = normalizeString(searchDisciplina);
        const searchDataAceitoNormalized = normalizeString(searchDataAceito);
        const searchDataResultadoNormalized = normalizeString(searchDataResultado);
        const searchProfessorNormalized = normalizeString(searchProfessor);

        const extamenteCumpriu = (val) =>
          searchCumpriu === "" || (searchCumpriu === "null" && val === null) || val == searchCumpriu;

        const extamenteConceito = (val) => searchConceito === "" || val == searchConceito;

        return (
          normalizeString(p.id_progressao).includes(searchIdNormalized) &&
          normalizeString(p.rm).includes(searchRmNormalized) &&
          normalizeString(p.nome).includes(searchNomeNormalized) &&
          normalizeString(p.turma_rh).includes(searchTurmaNormalized) &&
          normalizeString(p.disciplina_rh).includes(searchDisciplinaNormalized) &&
          normalizeString(p.aluno_aceitou).includes(searchDataAceitoNormalized) &&
          normalizeString(p.data_resultado).includes(searchDataResultadoNormalized) &&
          normalizeString(p.professor).includes(searchProfessorNormalized) &&
          extamenteCumpriu(p.cumpriu) &&
          extamenteConceito(p.conceito)
        );
      });

      await gerarPDF(dadosFiltrados);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
    } finally {
      setGerandoPDF(false);
    }
  }

  //////////////////////////////

  return (
    <Background>
      <Container>
        <Menus>
          <Title>Controle de Progressões</Title>
          <Buttons>
            <Button
              event={() => navigate("/home-progressao-coord")}
              width="8rem"
              margintop="2%"
              marginleft="1rem"
              placeholder="Voltar"
              backgroundcolor="#1a2e35"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              event={handleGerarPDF}
              width="8rem"
              margintop="2%"
              marginleft="1rem"
              placeholder={gerandoPDF ? "Gerando..." : "Gerar PDF"}
              backgroundcolor="#1a2e35"
              borderRadius="30px 30px 0px 0px"
              disabled={gerandoPDF}
            />
          </Buttons>
          {totalItems > 0 && <QtdeProgre>{totalItems} progressões</QtdeProgre>}
        </Menus>

        {/* Mostrar erro se houver */}
        {/* {error && (
          <div
            style={{
              padding: "1rem",
              backgroundColor: "#fee",
              color: "#c33",
              borderRadius: "4px",
              margin: "1rem 0",
              textAlign: "center",
            }}
          >
            {error}
          </div>
        )} */}

        <ContainerTable>
          <Table>
            <Theader>
              <tr>
                <Th style={{ width: "60px" }}>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="RM"
                      name="rm"
                      placeholdercolor="white"
                      event={(e) => {
                        setSearchRm(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th style={{ width: "200px" }}>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="Nome"
                      name="nome"
                      placeholdercolor="white"
                      event={(e) => {
                        setSearchNome(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th style={{ width: "200px" }}>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="Turma"
                      name="turma"
                      placeholdercolor="white"
                      event={(e) => {
                        setSearchTurma(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th style={{ width: "220px" }}>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="Disciplina"
                      name="disciplina"
                      placeholdercolor="white"
                      event={(e) => {
                        setSearchDisciplina(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th style={{ width: "180px" }}>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="Professor"
                      name="professor"
                      placeholdercolor="white"
                      event={(e) => {
                        setSearchProfessor(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th style={{ width: "120px" }}>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="Aceite"
                      name="data_aceitou"
                      placeholdercolor="white"
                      event={(e) => {
                        setSearchDataAceito(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th style={{ width: "120px" }}>Encerramento</Th>
                <Th style={{ width: "120px" }}>
                  <InputSelect
                    Style1={{ color: "#f8f8f8" }}
                    Style2={{ color: "#f8f8f8", backgroundColor: "#1a2e35" }}
                    Style3={{ color: "#f8f8f8", backgroundColor: "#1a2e35" }}
                    color="white"
                    name="cumpriu"
                    Options={optionsCumpriu}
                    OnChange={(e) => setSearchCumpriu(e.target.value)}
                  />
                </Th>
                <Th style={{ width: "120px" }}>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholder="Resultado"
                      name="data_resultado"
                      placeholdercolor="white"
                      event={(e) => {
                        setSearchDataResultado(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th style={{ width: "100px" }}>
                  <InputSelect
                    Style1={{ color: "#f8f8f8" }}
                    Style2={{ color: "#f8f8f8", backgroundColor: "#1a2e35" }}
                    Style3={{ color: "#f8f8f8", backgroundColor: "#1a2e35" }}
                    color="white"
                    name="conceito"
                    Options={optionsConceito}
                    OnChange={(e) => setSearchConceito(e.target.value)}
                  />
                </Th>
                <Th style={{ width: "90px" }}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    Sophia
                    <FaRegQuestionCircle
                      title={`Condição se foi ou não enviado ao Sophia pela secretaria.`}
                      size={16}
                      cursor="help"
                      className="icon"
                    />
                  </div>
                </Th>
              </tr>
            </Theader>
            <Tbody>
              {paginatedProgressoes.length > 0 ? (
                paginatedProgressoes.map((p, i) => (
                  <Trbody key={p.id || i}>
                    <Td title={p.rm}>{p.rm}</Td>
                    <Td title={p.nome}>
                      <span>{p.nome}</span>
                    </Td>
                    <Td title={p.turma_rh} className="max">
                      <span>{somenteCampo(p.turma_rh, false, true)}</span>
                    </Td>
                    <Td title={p.disciplina_rh} className="max">
                      <span>{somenteCampo(p.disciplina_rh, false, true)}</span>
                    </Td>
                    <Td title={p.professor} className="max">
                      <span>{somenteCampo(p.professor.split(",").pop(), false, true)}</span>
                    </Td>
                    <Td title={formatarData(p.aluno_aceitou)}>{formatarData(p.aluno_aceitou)}</Td>
                    <Td title={formatarData(p.data_fim)} className="max">
                      {formatarData(p.data_fim)}
                    </Td>
                    <Td title={formatarStatus(p.cumpriu).texto} className={formatarStatus(p.cumpriu).color}>
                      {formatarStatus(p.cumpriu).texto ?? <p>-</p>}
                    </Td>
                    <Td title={formatarData(p.data_resultado)}>{formatarData(p.data_resultado)}</Td>
                    <Td
                      title={p.conceito?.toUpperCase()}
                      className={p.conceito == "apto" ? "green" : p.conceito == "inapto" ? "red" : ""}
                    >
                      {p.conceito?.toUpperCase() ?? <p>-</p>}
                    </Td>
                    <Td style={{ textAlign: "center" }}>{p.enviado_ao_sofia ? "Sim" : "Não"}</Td>
                  </Trbody>
                ))
              ) : (
                <Trbody>
                  <Td
                    title={loading ? "Carregando..." : "Nenhuma progressão encontrada"}
                    colSpan="10"
                    style={{ textAlign: "center", padding: "2rem" }}
                  >
                    {loading ? "Carregando..." : "Nenhuma progressão encontrada"}
                  </Td>
                </Trbody>
              )}
            </Tbody>
          </Table>
        </ContainerTable>

        {/* Paginação melhorada */}
        {totalItems > limite && (
          <Menus>
            <Button
              event={() => handlePageChange(page - 1)}
              width="12%"
              placeholder="Anterior"
              backgroundcolor="#1a2e35"
              borderRadius="0px 0px 30px 30px"
              disabled={page <= 1 || loading}
            />

            <div className="page">
              <div style={{ color: totalPages <= 1 ? "#d0d0d0" : "", marginLeft: -30 }}>
                Página {page} de {totalPages}
              </div>
            </div>

            <Button
              event={() => handlePageChange(page + 1)}
              width="12%"
              placeholder="Próxima"
              backgroundcolor="#1a2e35"
              borderRadius="0px 0px 30px 30px"
              disabled={page >= totalPages || loading}
            />
          </Menus>
        )}

        {/* Navegação rápida de páginas */}
        {totalPages > 5 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "0.5rem",
              marginTop: "1rem",
            }}
          >
            {[...Array(Math.min(5, totalPages))].map((_, index) => {
              let pageNumber;
              if (totalPages <= 5) {
                pageNumber = index + 1;
              } else if (page <= 3) {
                pageNumber = index + 1;
              } else if (page >= totalPages - 2) {
                pageNumber = totalPages - 4 + index;
              } else {
                pageNumber = page - 2 + index;
              }

              return (
                <button
                  key={pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                  style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: page === pageNumber ? "#1a2e35" : "#f0f0f0",
                    color: page === pageNumber ? "white" : "#333",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "0.9em",
                  }}
                  disabled={loading}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>
        )}
      </Container>
    </Background>
  );
}

export default VisualizarProgreCoord;
